"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.springCalculation = void 0;
var defaultSpringConfig = {
  damping: 10,
  mass: 1,
  stiffness: 100,
  overshootClamping: false
};
var advanceCache = {};

function advance(_ref) {
  var animation = _ref.animation,
      now = _ref.now,
      config = _ref.config;
  var toValue = animation.toValue,
      lastTimestamp = animation.lastTimestamp,
      current = animation.current,
      velocity = animation.velocity;
  var deltaTime = Math.min(now - lastTimestamp, 64);
  var c = config.damping;
  var m = config.mass;
  var k = config.stiffness;
  var cacheKey = [toValue, lastTimestamp, current, velocity, c, m, k, now].join('-');

  if (advanceCache[cacheKey]) {
    return advanceCache[cacheKey];
  }

  var v0 = -velocity;
  var x0 = toValue - current;
  var zeta = c / (2 * Math.sqrt(k * m)); // damping ratio

  var omega0 = Math.sqrt(k / m); // undamped angular frequency of the oscillator (rad/ms)

  var omega1 = omega0 * Math.sqrt(1 - Math.pow(zeta, 2)); // exponential decay

  var t = deltaTime / 1000;
  var sin1 = Math.sin(omega1 * t);
  var cos1 = Math.cos(omega1 * t); // under damped

  var underDampedEnvelope = Math.exp(-zeta * omega0 * t);
  var underDampedFrag1 = underDampedEnvelope * (sin1 * ((v0 + zeta * omega0 * x0) / omega1) + x0 * cos1);
  var underDampedPosition = toValue - underDampedFrag1; // This looks crazy -- it's actually just the derivative of the oscillation function

  var underDampedVelocity = zeta * omega0 * underDampedFrag1 - underDampedEnvelope * (cos1 * (v0 + zeta * omega0 * x0) - omega1 * x0 * sin1); // critically damped

  var criticallyDampedEnvelope = Math.exp(-omega0 * t);
  var criticallyDampedPosition = toValue - criticallyDampedEnvelope * (x0 + (v0 + omega0 * x0) * t);
  var criticallyDampedVelocity = criticallyDampedEnvelope * (v0 * (t * omega0 - 1) + t * x0 * omega0 * omega0);
  var animationNode = {
    toValue: toValue,
    prevPosition: current,
    lastTimestamp: now,
    current: zeta < 1 ? underDampedPosition : criticallyDampedPosition,
    velocity: zeta < 1 ? underDampedVelocity : criticallyDampedVelocity
  };
  advanceCache[cacheKey] = animationNode;
  return animationNode;
}

var calculationCache = {};

function springCalculation(_ref2) {
  var _ref2$from = _ref2.from,
      from = _ref2$from === void 0 ? 0 : _ref2$from,
      _ref2$to = _ref2.to,
      to = _ref2$to === void 0 ? 1 : _ref2$to,
      frame = _ref2.frame,
      fps = _ref2.fps,
      _ref2$config = _ref2.config,
      config = _ref2$config === void 0 ? {} : _ref2$config;
  var cacheKey = [from, to, frame, fps, config.damping, config.mass, config.overshootClamping, config.stiffness].join('-');

  if (calculationCache[cacheKey]) {
    return calculationCache[cacheKey];
  }

  var animation = {
    lastTimestamp: 0,
    current: from,
    toValue: to,
    velocity: 0,
    prevPosition: 0
  };
  var frameClamped = Math.max(0, frame);
  var unevenRest = frameClamped % 1;

  for (var f = 0; f <= Math.floor(frameClamped); f++) {
    if (f === Math.floor(frameClamped)) {
      f += unevenRest;
    }

    var time = f / fps * 1000;
    animation = advance({
      animation: animation,
      now: time,
      config: _objectSpread(_objectSpread({}, defaultSpringConfig), config)
    });
  }

  calculationCache[cacheKey] = animation;
  return animation;
}

exports.springCalculation = springCalculation;